<template>
  <div class="full-height">
    <v-row no-gutters>
      <v-col cols="7" style="border-right: solid 1px black;" class="pa-4">
        <v-row no-gutters class="full-width text-center rounded-border" justify="center">
          Search Client
        </v-row>
        <v-row no-gutters class="full-width justify-space-between mt-4">
          <div class="col-4 text-center align-content-center rounded-border">
            <span>Produits</span>
          </div>
          <div class="col-4 text-center align-content-center">
            <v-btn text class="rounded-border px-2 no-caps-btn" :disabled="isButtonDisable" @click="downloadCustomersCSV">
              Télécharger la sélection
            </v-btn>
          </div>
        </v-row>
        <v-text-field
          v-model="customerToSearch"
          class="mb-3"
          color="third"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          @keydown.enter="search"
        />
        <v-data-table
          v-model="selectedCustomers"
          :height="tableHeight"
          :headers="headers"
          :search="customerToSearch"
          checkbox-color="third"
          :items="tableItem"
          item-key="uuid"
          item-text="fullname"
          :options="options"
          :items-per-page="options.itemsPerPage"
          :hide-default-footer="true"
          show-select
          :custom-filter="filterCustomers"
          @item-selected="selectCustomer"
        >
          <template #item.actions="{ item }">
            <v-btn small color="third" class="white--text" @click="customerPage(item)">
              détails
            </v-btn>
          </template>
        </v-data-table>
        <div class="text-center py-2 mt-4">
          <v-pagination
            v-model="currentPage"
            light
            :disabled="loading"
            :length="totalPage"
            :total-visible="10"
            :class="{'disabled': loading }"
            color="third"
          />
        </div>
      </v-col>
      <v-col cols="5" class="pa-4 overflow-y-auto full-height">
        <v-row no-gutters class="full-width text-center rounded-border" justify="center">
          Client à ajouter au planificateur
        </v-row>
        <v-text-field
          v-model="selectedCustomerSearch"
          class="mb-3"
          color="third"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
        <v-data-table
          :height="tableHeight"
          :headers="headers"
          :items="selectedCustomers"
          item-key="uuid"
          :search="selectedCustomerSearch"
          checkbox-color="third"
          item-text="fullname"
          :options="options"
          :hide-default-footer="true"
          :items-per-page="-1"
          :disable-pagination="true"
          show-select
          :custom-filter="filterCustomers"
          @item-selected="selectItem"
        />
        <v-row justify="center" no-gutters class="pt-4">
          <v-btn v-if="canUserPerformAction" color="third" class="white--text" height="32" :disabled="isButtonDisable" @click="addCustomersToList">
            Ajouter au planificateur
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref, computed, onBeforeMount, watch } from '@vue/composition-api';
import store from '@/store';
import router from '@/router';
import { searchCustomer } from '@/helpers/search';
import { downloadCSV, sendNotification } from '../helpers/utils';

export default {
  setup (_, context) {
    const customers = ref([]);
    const loading = ref(false);
    const currentPage = ref(1);
    const totalPage = ref(1);
    const customerToSearch = ref(null);
    const selectedCustomerSearch = ref(null);
    const selectedCustomers = ref([]);
    const panel = ref([0, 1]);
    const customerDiselected = ref([]);
    const tableHeight = computed(() => window.innerHeight * 0.6);
    const visitedPage = ref({});

    const headers = [
      { text: 'Full Name', value: 'fullname', width: '30%' },
      { text: 'Email', value: 'email', width: '50%' },
      { text: '', value: 'actions', width: '20%' }
    ];

    const options = ref({
      page: 1,
      itemsPerPage: 10
    });

    const tableItem = computed(() => {
      const start = (currentPage.value - 1) * options.value.itemsPerPage;
      return customerToSearch.value ? customers.value : customers.value.slice(start, start + options.value.itemsPerPage);
    });

    const customerOnPlanner = computed(() => store.state.selectedCustomers);

    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    const isButtonDisable = computed(() => !selectedCustomers.value.length && !customerDiselected.value.length);

    const getCustomer = async (start = 0, limit = options.value.itemsPerPage) => {
      const { hits, nbHits } = await searchCustomer('', null, start, limit);

      totalPage.value = Math.ceil(nbHits / options.value.itemsPerPage);
      const transformedCustomers = hits.map(r => ({ ...r, fullname: `${r.firstname} ${r.lastname}` }));
      transformedCustomers.map(c => customers.value.push(c));

      transformedCustomers.map(c => {
        const isCustomerOnPlanner = customerOnPlanner.value.some(cust => cust.uuid === c.uuid);

        if (isCustomerOnPlanner) {
          selectedCustomers.value.push(c);
        }
      });

      visitedPage.value[currentPage.value] = transformedCustomers;
    };

    const selectItem = ({ item, value }) => {
      if (value) {
        const index = selectedCustomers.value.findIndex(c => c.uuid === item.uuid);

        if (index !== -1) {
          selectedCustomers.value.splice(index, 1);
        }

        const isItemDeselected = customerDiselected.value.some(cust => cust.uuid === item.uuid);

        if (!isItemDeselected) {
          customerDiselected.value.push(item);
        }
      }
    };

    const selectCustomer = ({ item, value }) => {
      if (value) {
        const index = customerDiselected.value.findIndex(c => c.uuid === item.uuid);

        if (index !== -1) {
          customerDiselected.value.splice(index, 1);
        }
      }
    };

    const addCustomersToList = () => {
      const customersToUpdate = [...customerOnPlanner.value];

      selectedCustomers.value.map(customer => {
        const isCustomerOnList = customersToUpdate.some(c => c.uuid === customer.uuid);

        if (!isCustomerOnList) {
          customersToUpdate.push({ ...customer, fullname: `${customer.firstname} ${customer.lastname}` });
        }
      });

      customerDiselected.value.map(cust => {
        const index = customersToUpdate.findIndex(c => c.uuid === cust.uuid);

        if (index !== -1) {
          customersToUpdate.splice(index, 1);
        }
      });

      store.commit('setSelectedCustomers', customersToUpdate);

      if (context.root.$route.path !== '/') {
        router.push({ path: '/' });
      }
    };

    const search = async () => {
      const { hits } = await searchCustomer(customerToSearch.value);

      hits.map(customer => {
        const isCustomerAlreadyOnList = customers.value.some(c => c.uuid === customer.uuid);

        if (!isCustomerAlreadyOnList) {
          customers.value.push({ ...customer, fullname: `${customer.firstname} ${customer.lastname}` });
        }
      });
    };
    const filterCustomers = (_, searchValue, item) => item.fullname.toLowerCase().includes(searchValue.toLowerCase()) || item.email.toLowerCase().includes(searchValue.toLowerCase());

    watch(currentPage, async () => {
      const pageAlreadyVisited = Object.keys(visitedPage.value).some(key => parseInt(key) === currentPage.value);

      if (!pageAlreadyVisited) {
        const start = (currentPage.value - 1) * options.value.itemsPerPage;

        await getCustomer(start);
      }
    });

    const customerPage = item => {
      router.push({
        name: 'ResourcePage',
        params: {
          type: 'customer',
          uuid: item.uuid
        },
        query: { returnTo: 'PlannerCustomer' }
      });
    };

    onBeforeMount(async () => {
      await getCustomer();
    });

    const downloadCustomersCSV = () => {
      if (!selectedCustomers.value.length) {
        sendNotification('error', 'Vous devez sélectionner au moins un client.');
        return;
      }

      downloadCSV([{ headers: headers.filter(h => h.text), data: selectedCustomers.value.map(customer => ({ name: customer.fullname, email: customer.email })) }], 'Pégase Planificateur', { success: 'Téléchargement réussi.', error: 'Échec du téléchargement.' });
    };

    return { downloadCustomersCSV, customerPage, selectedCustomerSearch, selectCustomer, customerDiselected, filterCustomers, search, addCustomersToList, selectItem, customers, headers, options, loading, currentPage, totalPage, customerToSearch, tableItem, visitedPage, selectedCustomers, canUserPerformAction, panel, isButtonDisable, tableHeight };
  }
};

</script>
